import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { IHttpErrorPayload, HttpRequestPayload, IHttpSuccessPayload } from '@core/models';
import { HttpProviderService } from 'src/app/core/services/http-provider/http-provider.service';
import { ITransferBeneficiaryRequestModel, ITransferBeneResModel } from '../models/transfer-beneficiary.model';
import { PreLoginService } from 'src/app/pre-login/pre-login.service';

@Injectable({
  providedIn: 'root'
})
export class TransferBeneficiaryService {

  constructor(private httpProvider : HttpProviderService,private _preLoginService: PreLoginService) { }

  transferBeneficiary(paymentKey, payload: ITransferBeneficiaryRequestModel){
    const payloadData = payload;
    const httpRequest : HttpRequestPayload = {
      resource : '/'+paymentKey,
      method : "POST",
      body : payloadData
    }
    return this.httpProvider.invokeApi(httpRequest).pipe(map((response : IHttpSuccessPayload<any>) => {
      const tranferBene:ITransferBeneResModel  = {
        httpStatus : response.status,
        refNo: response.body[paymentKey].refNo
      };
      if (response.status == 201) {
        this._preLoginService.setUserTwoFactor({ email: response.body[paymentKey]?.twoFactor?.email, mobile: response.body[paymentKey]?.twoFactor?.mobile });
      }
      return tranferBene;
    },
    catchError((err : IHttpErrorPayload) => { 
      return throwError(err)
    })));
  }
  fetchTransferDetails(paymentKey,requestReference): Observable<any> {
    const httpRequest : HttpRequestPayload = {
      resource : `/${paymentKey}/${requestReference}`,
      method : "GET"
    }
    return this.httpProvider.invokeApi(httpRequest).pipe(map((response : IHttpSuccessPayload<any>) => {
      const requestChequeBookResponse = response.body[paymentKey]
      return requestChequeBookResponse
    },
    catchError((err : IHttpErrorPayload) => { 
      return throwError(err)
    })));
  }


}
